import actionCreatorFactory from 'typescript-fsa';
import { IThunk } from 'ui/reducers/store';
import * as clinicalAPI from 'ui/interfaces/api/clinical';
import * as widgetAPI from 'ui/interfaces/api/clinical/widget';
import { IAxiosResponseError } from 'ui/utils/axios';
import { get } from 'lodash';
import { mixpanelService } from 'ui/utils/mixpanel';
import { removeEmptyKeysFromObject } from 'patientCommons/utils/commons';

const actionCreator = actionCreatorFactory('PATIENTSIDEBAR/CLINICAL');

const actions = {
  getClinicalConfig: actionCreator.async<void, clinicalAPI.POST.IResponse, clinicalAPI.POST.IResponseError>(
    'getClinicalConfig',
  ),
  getWidgetData: actionCreator.async<widgetAPI.GET.IStarted, widgetAPI.GET.IResponse, widgetAPI.GET.IResponseError>(
    'getWidgetData',
  ),
};

const thunks = {
  getClinicalConfigAsync: (body: clinicalAPI.POST.IRequest): IThunk => dispatch => {
    dispatch(actions.getClinicalConfig.started());
    clinicalAPI.POST.service(body)
      .then(({ data }) => {
        dispatch(
          actions.getClinicalConfig.done({
            result: data,
            params: undefined,
          }),
        );
        const metaData = removeEmptyKeysFromObject({
          patient_id: get(data, 'meta.request_context.empi', ''),
          care_protocol_name: get(data, 'meta.response_meta?.display_name', ''),
        });
        mixpanelService.track(`P360: DP360 - Clinical Data App loaded`, {
          ...metaData,
        });
      })
      .catch((error: IAxiosResponseError) => {
        dispatch(
          actions.getClinicalConfig.failed({
            error: get(error, 'response.data', 'Something Went Wrong!'),
            params: undefined,
          }),
        );
      });
  },
  getWidgetDataAsync: (API: string, id: string): IThunk => dispatch => {
    dispatch(actions.getWidgetData.started({ id }));
    widgetAPI.GET.service(API)
      .then(({ data }) => {
        dispatch(
          actions.getWidgetData.done({
            result: data,
            params: { id },
          }),
        );
      })
      .catch((error: IAxiosResponseError) => {
        dispatch(
          actions.getWidgetData.failed({
            error: get(error, 'response.data', 'Something Went Wrong!'),
            params: { id },
          }),
        );
      });
  },
};

export default { ...actions, ...thunks };
